module.exports = __webpack_public_path__ + "src/client/assets/img/taxfyle-icon-256px.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/taxfyle-icon-256px.png
// module id = 217
// module chunks = 0